import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/(auth)/reset-password/page.tsx");
